const TestCases = [
    {
        TestCaseNumber: "VRSKTC1",
        GivenName: "GLORIA",
        Surname: "NORTHCRAFT",
        DOB: "19920101",        
        Street1: "9151 NEWTON ST"
        ,City: "WESTMINSTER"
        ,StateCode: "CO",
        Zip: 80031,
        Scenario: "One policy in CV with A claim in Aplus Auto"
    },
    /*
    {
        TestCaseNumber: "VRSKTC2",
        GivenName: "CINDY",
        Surname: "JEFFERSON",
        DOB: "19320101",
        
            Street1: "671 CODY CT"
        ,City: "LAKEWOOD",
        StateCode: "CO",
        Zip: 80215,
        Scenario: "One policy in CV with two claims in Aplus Auto.  Listed driver is from MVR"
    },
    {
        TestCaseNumber: "VRSKTC3",
        GivenName: "SILVIA",
        Surname: "CRUZ",
        DOB: "19540101",
        
            Street1: "1622 KICKAPOO RD"
        ,City: "PUEBLO",
        StateCode: "CO",
        Zip: 81001,
        Scenario: "One policy with Credit Header's Previous and Current addresses."
    },
    {
        TestCaseNumber: "VRSKTC4",
        GivenName: "JOSEPH",
        Surname: "FEESLER",
        DOB: "19760101",
        
            Street1: "10080 LEXINGTON DR"

        ,City: "COLORADO SPRINGS",
        StateCode: "CO",
        Zip: 80920,
        Scenario: "One cancelled policy in CV With one claim in Aplus auto.  Primary driver present in Epsilon. "
    },
    {
        TestCaseNumber: "VRSKTC5",
        GivenName: "JENNIFER",
        Surname: "WUEST",
        DOB: "19930101",
        
            Street1: "7374 E 28TH AV"

        ,City: "DENVER",
        StateCode: "CO",
        Zip: 80238,
        Scenario: "Two inforce policies for the same driver in CV with same coverage limits in both the policies."
    },
    {
        TestCaseNumber: "VRSKTC6",
        GivenName: "ANDERSON",
        Surname: "BERTHA",
        DOB: "19910101",
        
            Street1: "15806 ROAD 20"

        ,City: "CORTEZ",
        StateCode: "CO",
        Zip: 81321,
        Scenario: "One policy in CV and 3 Claims found in Aplus Auto based DOB and DL number match."
    },
    {
        TestCaseNumber: "VRSKTC7",
        GivenName: "PATRICIA",
        Surname: "GRISHAM",
        DOB: "19750101",
        
            Street1: "373 S 3RD AV"

        ,City: "BRIGHTON",
        StateCode: "CO",
        Zip: 80601,
        Scenario: "One Policy in CV with three claims in Aplus Auto. Two claims on same day with different loss types."
    },
    */   
    {
        TestCaseNumber: "VRSKTC8",
        GivenName: "WILLIAM",
        Surname: "VARNEY",
        DOB: "19780101",
        
            Street1: "2809 VINE DR"

        ,City: "FORT COLLINS",
        StateCode: "CO",
        Zip: 80521,
        Scenario: "One Expired Policy in CV. Listed Driver is from MVR."
    },
    /*
    {
        TestCaseNumber: "VRSKTC9",
        GivenName: "JOEL",
        Surname: "BEITER",
        DOB: "19810101",
        
            Street1: "18020 WOODHAVEN DR"

        ,City: "COLORADO SPRINGS",
        StateCode: "CO",
        Zip: 80908,
        Scenario: "Two inforce policies in CV for the same driver with different Coverage limits."
    },
    {
        TestCaseNumber: "VRSKTC10",
        GivenName: "ELIDA",
        Surname: "BENAVIDES",
        DOB: "19500101",
        
            Street1: "680 HILL ST"

        ,City: "SPRINGFIELD",
        StateCode: "CO",
        Zip: 81073,
        Scenario: "Two policies in CV with two claims in Aplus Auto. Seconds policy found based on SSN Recursive search."
    },
    {
        TestCaseNumber: "VRSKTC11",
        GivenName: "DONNA",
        Surname: "PETRUZELLA",
        DOB: "19610101",
        
            Street1: "13173 RARITAN ST"

        ,City: "DENVER",
        StateCode: "CO",
        Zip: 80234,
        Scenario: "One policy in CV with two claims in Aplus auto."
    },
    {
        TestCaseNumber: "VRSKTC12",
        GivenName: "RICHARD",
        Surname: "BEAUMONT",
        DOB: "19890101",
        
            Street1: "12356 WOLFF DR"

        ,City: "BROOMFIELD",
        StateCode: "CO",
        Zip: 80020,
        Scenario: "One policy in CV with 3 claims in Aplus Auto 3rd claim found on DL recursive search."
    },
    {
        TestCaseNumber: "VRSKTC13",
        GivenName: "LUCILE",
        Surname: "MALLORY",
        DOB: "19730101",
        
            Street1: "10654 BELLE CREEK BV"

        ,City: "HENDERSON",
        StateCode: "CO",
        Zip: 80640,
        Scenario: "One policy in CV with two claims in Aplus Auto. Listed driver has full MVR report "
    },
    {
        TestCaseNumber: "VRSKTC14",
        GivenName: "JOHN",
        Surname: "BOSTON",
        DOB: "19900101",
        
            Street1: "290 LEONARD LN"

        ,City: "NORTHGLENN",
        StateCode: "CO",
        Zip: 80233,
        Scenario: "One policy in CV with differnet coverage limits."
    },
    {
        TestCaseNumber: "VRSKTC15",
        GivenName: "Stephen",
        Surname: "Coleman",
        DOB: "19850201",
        
            Street1: "5123 Clay St"

        ,City: "Denver",
        StateCode: "CO",
        Zip: 80221,
        Scenario: "One policy in CV with 5 drivers and 5 Vins."
    },
    {
        TestCaseNumber: "VRSKTC16",
        GivenName: "KATHLEEN",
        Surname: "LUGARA",
        DOB: "19570101",
        
            Street1: "1794 RIO SECCO RD"

        ,City: "PEYTON",
        StateCode: "CO",
        Zip: 80831,
        Scenario: "One policy in CV with One of the coverage removed in the middle and added in the last  transaction."
    },
    {
        TestCaseNumber: "VRSKTC17",
        GivenName: "SERETHA",
        Surname: "POPE",
        DOB: "19670101",
        
            Street1: "2048 HANOVER ST"

        ,City: "AURORA",
        StateCode: "CO",
        Zip: 80010,
        Scenario: "Two Policies for the same driver, same address, Same Vehicle. With different Carrier. No claims in Auto."
    },
    {
        TestCaseNumber: "VRSKTC18",
        GivenName: "CRITTIE",
        Surname: "KRIEGER",
        DOB: "19770101",
        
            Street1: "44503 HOMESTEAD RD"

        ,City: "ELIZABETH",
        StateCode: "CO",
        Zip: 80107,
        Scenario: "Two different policies with same address with different carrier. Primary driver in 1st Policy is Secondary driver in Second policy. No Claims in Auto."
    },
    {
        TestCaseNumber: "VRSKTC19",
        GivenName: "ANDREW",
        Surname: "HASELTINE",
        DOB: "19810101",
        
            Street1: "30799 HILLTOP DR"

        ,City: "EVERGREEN",
        StateCode: "CO",
        Zip: 80439,
        Scenario: "Missing Aplus Auto, MVR data source."
    },
    {
        TestCaseNumber: "VRSKTC20",
        GivenName: "JUDITH",
        Surname: "ELLISALVES",
        DOB: "19820101",
        
            Street1: "4810 CAMEO WY"

        ,City: "COLORADO SPRINGS",
        StateCode: "CO",
        Zip: 80919,
        Scenario: "No matches found in POLK and MVR"
    },
    {
        TestCaseNumber: "VRSKTC21",
        GivenName: "Ann",
        Surname: "Martin",
        DOB: "19821112",
        
            Street1: "4145 Brightside Ct"

        ,City: "Colorado Springs",
        StateCode: "CO",
        Zip: 80916,
        Scenario: "Just Aplus Auto claims. No CV found. Two claims for the same person, same policy and same VINS."
    },
    {
        TestCaseNumber: "VRSKTC22",
        GivenName: "JASON",
        Surname: "STARK",
        DOB: "19440101",
        
            Street1: "1956 LAWRENCE ST"

        ,City: "DENVER",
        StateCode: "CO",
        Zip: 80202,
        Scenario: "No matches found in CV, POLK and MVR"
    }
    */
];

export default TestCases;


// WEBPACK FOOTER //
// ./src/data/testCases.js